import { createAction } from '@reduxjs/toolkit';

export interface PageDataSlice {
  cacheKey: string;
  title: string;
  data: any;
}

const setPageDataSlice = createAction('currentPage/setPageDataSlice', (pageDataSlice: PageDataSlice) => {
  if (!pageDataSlice.cacheKey) {
    console.warn('currentPage/setPageDataSlice: cacheKey is required', pageDataSlice);
  }
  if (!pageDataSlice.title) {
    console.warn('currentPage/setPageDataSlice: title is required', pageDataSlice);
  }
  return {
    payload: pageDataSlice,
  };
});

const clearPageDataSlice = createAction('currentPage/clearPageDataSlice', (cacheKey: string) => ({
  payload: cacheKey,
}));

export const currentPageActions = {
  setPageDataSlice,
  clearPageDataSlice,
};
